module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"transplant_hospital":"Transplantation Hospital ID","dialysis_hospital":"Dialysis Hospital ID","dialysis_provider":"Dialysis Provider(s)","blood_type":"Blood Type"},"fr":{"transplant_hospital":"Transplantation Hospital ID","dialysis_hospital":"Dialysis Hospital ID","dialysis_provider":"Dialysis Provider(s)","blood_type":"Blood Type"}}')
  delete Component.options._Ctor
}
